import { render, staticRenderFns } from "./AuthLeftSideComponent.vue?vue&type=template&id=40b4ece4"
import script from "./AuthLeftSideComponent.vue?vue&type=script&lang=js"
export * from "./AuthLeftSideComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports